var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlayVideo = function SvgPlayVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Play btn")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockup---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subcollection---inside-view",
    transform: "translate(-355.000000, -639.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "container",
    transform: "translate(280.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(20.000000, 432.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "img"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Play-btn",
    transform: "translate(55.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,20.0003158 C40,31.0460581 31.0454266,40 19.9996842,40 C8.95457345,40 0,31.0460581 0,20.0003158 C0,8.95457345 8.95457345,0 19.9996842,0 C31.0454266,0 40,8.95457345 40,20.0003158 Z",
    id: "Stroke-1",
    fillOpacity: 0.5,
    fill: "#000000",
    transform: "translate(20.000000, 20.000000) scale(-1, 1) translate(-20.000000, -20.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5864347,12.2387033 C14.3059144,11.9906661 13.9038988,11.9305551 13.562949,12.0836801 C13.2200908,12.2374378 13,12.575958 13,12.9492794 L13,27.5214662 C13,27.8954203 13.2200908,28.2339405 13.562949,28.3870655 C13.6882608,28.4433801 13.8212058,28.4705882 13.9541508,28.4705882 C14.1825109,28.4705882 14.4089627,28.3889637 14.5864347,28.2320422 L26.6781331,20.8404697 C26.8829575,20.6607693 27,20.4013426 27,20.1298937 C27,19.8584448 26.8829575,19.5996509 26.6781331,19.4193177 L14.5864347,12.2387033 Z",
    id: "Fill-5",
    fill: "#FFFFFF"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlayVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/playVideo.85466f85.svg";
export { ForwardRef as ReactComponent };